export default __webpack_public_path__ + "93039eb920c17dd35c72690f3df0e7e9.svg";